// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file controls/v1/special_control_type.proto (package controls.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file controls/v1/special_control_type.proto.
 */
export const file_controls_v1_special_control_type: GenFile = /*@__PURE__*/
  fileDesc("CiZjb250cm9scy92MS9zcGVjaWFsX2NvbnRyb2xfdHlwZS5wcm90bxILY29udHJvbHMudjEqVwoSU3BlY2lhbENvbnRyb2xUeXBlEiQKIFNQRUNJQUxfQ09OVFJPTF9UWVBFX1VOU1BFQ0lGSUVEEAASGwoXU1BFQ0lBTF9DT05UUk9MX1RZUEVfQUkQAUK4AQoPY29tLmNvbnRyb2xzLnYxQhdTcGVjaWFsQ29udHJvbFR5cGVQcm90b1ABWj9naXRodWIuY29tL2xlbWEuYWkvbGVtbWF0YS9hcGkvcHJvdG8vZ2VuL2NvbnRyb2xzL3YxO2NvbnRyb2xzdjGiAgNDWFiqAgtDb250cm9scy5WMcoCC0NvbnRyb2xzXFYx4gIXQ29udHJvbHNcVjFcR1BCTWV0YWRhdGHqAgxDb250cm9sczo6VjFiBnByb3RvMw");

/**
 * SpecialControlType marks a control as belonging to a special catalog. An
 * ordinary control has no type and leaves this unset.
 *
 * @generated from enum controls.v1.SpecialControlType
 */
export enum SpecialControlType {
  /**
   * @generated from enum value: SPECIAL_CONTROL_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SPECIAL_CONTROL_TYPE_AI = 1;
   */
  AI = 1,
}

/**
 * Describes the enum controls.v1.SpecialControlType.
 */
export const SpecialControlTypeSchema: GenEnum<SpecialControlType> = /*@__PURE__*/
  enumDesc(file_controls_v1_special_control_type, 0);

